import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import compact from 'lodash/compact';

import {
  STYLE_PRESET_SCOPE_ALL
} from 'zoomforth_theme_editor/const/style_sets.js';

// Useful if you need the object structure for a style preset with no real
// substance to it.
export const DUMMY_STYLE_PRESET = {
  displayName: '',
  className: '',
  scope: STYLE_PRESET_SCOPE_ALL,
  variables: {},
  isDefault: false,
  isDummy: true
};

export const convertStylePresetsToOptionsList = (stylePresets, { includeDefaultValue = true } = {})=> {
  const sortedStylePresets = sortBy(
    map(stylePresets, ({ display_name, classname, variables, scope, priority })=> ({
      displayName: display_name,
      className: classname,
      isDefault: false,
      isDummy: false,
      variables,
      priority,
      scope
    })),
    'priority'
  );

  const defaultStylePreset = {
    displayName: 'None',
    className: '',
    scope: STYLE_PRESET_SCOPE_ALL,
    variables: {},
    isDefault: true,
    isDummy: false
  };

  return compact([
    includeDefaultValue && defaultStylePreset,
    ...sortedStylePresets
  ]);
};
